module.exports = __webpack_public_path__ + "img/10.3b88ddd7.jpeg";